module.exports = __webpack_public_path__ + "static/media/beach-umbrella.cf7f7f6c.png";